module.exports = __webpack_public_path__ + "static/react-screenshot-66043e914de7d74cc6efd3cc8bddf423.png";